import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'

const p = 'password'
const t = 'text'


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleInput',
  props: {
  type: {
    type: String,
    default: 'text',
  },
  placeholder: {
    type: String,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

const emit = __emit

const inputType = ref(props.type)

/* eslint-disable */
const isPasswordField = inputType.value === p

const toggleType = () => inputType.value = inputType.value === p ? t : p



const __returned__ = { props, emit, p, t, inputType, isPasswordField, toggleType, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})